export default "__VITE_ASSET__11917310__"